import React, { useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { toast } from 'sonner';
import Logo from '../components/Logo';
import { makeRESTApiRequest } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';
import { saveUserToLocal } from '../helpers/session';
import SignupForm from '../components/login/SignupForm';
import { Redirect } from 'react-router';
import { isAdmin, isClient } from '../helpers/global';
const Signup = () => {
  const [signInError, setSignInError] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);

  const history = useHistory();

  const onSignupFormSubmit = async form => {
    setSignInError('');
    const { name, phone, newAdmin } = form;

    if (newAdmin.password !== newAdmin.confirmPassword) {
      setSignInError('Passwords do not match');
      return;
    }

    setFormSubmitting(true);

    try {
      const { response: authResult, error } = await makeRESTApiRequest({
        endpoint: ENDPOINTS.ORG_SIGN_UP,
        requestBody: { name, phone, newAdmin }
      });

      setFormSubmitting(false);
      if (error) {
        toast.error(error);
        return;
      }

      // authResult includes the newly created org and the admin under newAdmin.
      const { newAdmin: orgAdmin = {}, token: tokenForOrgAdmin, ...organization } = authResult || {};

      // Persist admin as the user and keep org details nested under `organization`
      const userToPersist = {
        ...orgAdmin,
        token: tokenForOrgAdmin,
        organization
      };

      saveUserToLocal(userToPersist, true);

      history.push('/org-dashboard?onboarding=true');
    } catch (e) {
      setFormSubmitting(false);
      toast.error('Something went wrong! Please try again');
      console.log(e);
    }
  };

  const loggedInEmail = localStorage.getItem('user-email');
  const role = localStorage.getItem('user-role');

  if (loggedInEmail && role) {
    return (
      <Redirect
        from="/signup"
        to={isClient(role) ? '/org-dashboard' : isAdmin(role) || isSalesPerson(role) ? '/dashboard' : '/services/pipeline'}
      />
    );
  }

  return (
    <Container fluid className="h-100">
      <Row className="h-100">
        <Col xs={1} className="bg-dark d-block"></Col>
        <Col
          xs={11}
          className="bg-light h-100 d-flex flex-column p-0"
          style={{ overflowY: 'auto', overflowX: 'hidden' }}
        >
          <Row className="justify-content-center flex-grow-1 py-2 px-0 px-md-5">
            <Col xs={10} md={8} lg={6} xl={5} className="align-self-center">
              <Card className="p-2 border-0 bg-transparent">
                <Card.Header className="p-0 mt-3 mb-2 bg-transparent border-0 text-center">
                  <div className="text-center">
                    <Logo />
                  </div>
                  <h6 className="text-muted mx-2 mt-4">
                    <div className="mb-2 font-weight-medium xlargeFont">
                      <span className="text-dark ">Hello!</span> Welcome to <b>Accurate Lien Search</b>. <br />
                    </div>
                    <b className="text-dark font-weight-medium largeFont">Fill out the information below to register</b>
                  </h6>
                </Card.Header>
                <Card.Body>
                  <SignupForm onSubmit={onSignupFormSubmit} formSubmitting={formSubmitting} error={signInError} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;
